import React from "react";
import { t } from "@lingui/macro";
import { i18n } from "idc-ui-react";
// Fluent UI
import { Stack, Text } from "@fluentui/react";

export default function AccessDenied({ text }) {
  return (
    <Stack
      grow
      verticalFill
      verticalAlign="center"
      horizontalAlign="center"
      tokens={{ childrenGap: 16 }}
    >
      <Text variant="xxLargePlus">{i18n._(t`Access Denied`)}</Text>
      <Stack
        verticalAlign="center"
        horizontalAlign="center"
        tokens={{ childrenGap: 8 }}
      >
        <Text variant="large">{text}</Text>
      </Stack>
    </Stack>
  );
}
